import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-todays-opened-tickets',
  templateUrl: './todays-opened-tickets.component.html',
  styleUrls: ['./todays-opened-tickets.component.css']
})
export class TodaysOpenedTicketsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetTodaysOpenTickets();
  }

  GetTodaysOpenTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getTodaysOpenTickets()
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}
}



// WEBPACK FOOTER //
// ./src/app/reports/todays-opened-tickets/todays-opened-tickets.component.ts